import angular from 'angular'
import packageModalPage from './view/packageModal.html'
import utils from 'utils'
class orgAddCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, globalFn, $stateParams, formvalidateApi, $rootScope) {
        $scope.userType = $rootScope.userInfo.user.userType
        // 有缓存参数，从缓存中取orgOwnerShip
        $scope.orgOwnerShip = JSON.parse(localStorage.user_info).user.orgOwnership
        if (JSON.parse(localStorage.user_info).org) {
            $scope.parentOrgId = JSON.parse(localStorage.user_info).org.parentOrgId
        }
        $scope.userTypeOrgId = $scope.userType ? $scope.orgOwnerShip : 0
        // storage 传值 传整个org对象 目前只需要orgId， treeLevelCode
        $scope.notParent = 1
        const currentOrgStr = sessionStorage.getItem('selectedOrg')
        const { orgId } = $stateParams
        if (!currentOrgStr) {
            $state.go('system.syssetting.org.list')
            return
        } else {
            $scope.currentOrg = JSON.parse(currentOrgStr)
        }
        if (orgId) {
        }
        // 获取所有主管税局信息--百丽接口
        function getAllTaxBureau() {
            httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                $scope.taxBureauList = res.data.value
            })
        }
        getAllTaxBureau()
        // 根据id 获取主管税局信息--百丽接口
        function getTaxBureauById(id) {
            httpRequest.get_getTaxBureauById(id).then((res) => {
                console.log(res)
            })
        }
        // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
        //localStorage.getItem('id_token')
        function getBelleRegion() {
            httpRequest.get_getBelleRegion().then((res) => {
                $scope.belleRegionList = res.data.value
            })
        }
        getBelleRegion()
        $scope.searchManagCity = function () {
            let params = {
                affiliation: $scope.orgForm.saleInfo.affiliation,
                regionNo: $scope.orgForm.saleInfo.regionNo,
            }
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionNameList = res.data.value
            })
        }

        $scope.reset = function reset(msg) {
            $scope.orgForm = {
                parentOrgId: '', // 上级机构id
                parentLevelCode: '',
                parentOrgName: '',
                orgStatus: 1,
                invoiceFlag: 1,
                orgName: '',
                orgAddress: '',
                orgPhone: '',
                packIdList: [],
                saleInfo: {
                    accountingCode: '',
                    companyProperty: '0',
                    industryCode: '',
                    legalName: '',
                    registerType: '',
                    saleBankAccount: {
                        bank: '',
                        bankAccount: '',
                    },
                    saleCreditCode: '',
                    taxplayerType: '1',
                },
            }
            utils.loading('正在加载···')
            //功能包默认全选
            httpRequest.get_PackOfTenantOrOrg().then((res) => {
                if (msg) logger.logSuccess(msg)
                $scope.orgForm.packIdList = res.data.value.map((x) => x.packId)
            })
            if (orgId) {
                $scope.isEdit = true
                httpRequest.post_qryOrgDetail({ detailOrgId: orgId }).then((res) => {
                    $scope.orgForm = res.data.value.org
                    $scope.orgForm.saleInfo.affiliation = $scope.orgForm.saleInfo.departmentNo
                    $scope.orgForm.saleInfo.regionNo = $scope.orgForm.saleInfo.regionNo
                    $scope.searchManagCity()
                    $scope.cityRegionNo = $scope.orgForm.saleInfo.managerCityNo
                    $scope.orgForm.packIdList = res.data.value.packList.map((x) => x.packId)
                    selectParentNode()
                })
            } else {
                $scope.orgForm.parentOrgId = $scope.currentOrg.orgId // 上级机构id
                $scope.orgForm.parentLevelCode = $scope.currentOrg.treeLevelCode
                $scope.orgForm.parentOrgName = $scope.currentOrg.orgName
                selectParentNode()
            }
        }
        $scope.reset()
        //机构树的check配置信息
        $scope.config = {
            check: {
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
                chkStyle: 'radio',
                radioType: 'all',
            },
        }
        function selectParentNode() {
            httpRequest.get_organization($scope.userTypeOrgId).then((res) => {
                utils.loaded()
                $scope.orgList = res.data.value
                //编辑 过滤本企业机构数据
                if (orgId && $scope.orgList.length > 1) {
                    $scope.orgList = $scope.orgList.filter((x) => {
                        return x.treeLevelCode.indexOf($scope.orgForm.treeLevelCode) !== 0
                    })
                }
                for (var i = 0; i < $scope.orgList.length; i++) {
                    // 新增
                    if (!orgId && $scope.orgList[i].orgId == $scope.currentOrg.orgId) {
                        $scope.queryOrgConfig.defaultSelect = [$scope.orgList[i]]
                        $scope.selectedOrgList = [$scope.orgList[i]]
                        //  排序 当前父级id
                        $scope.orgForm.parentOrgId = $scope.orgList[i].orgId
                        // 非admin
                        $scope.userType && $scope.filterData($scope.orgList[i].notTreeStructure, $scope.orgList, $scope.orgList[i].parentOrgId)
                        break
                    }
                    // 编辑
                    if (orgId && $scope.orgList[i].orgId == $scope.orgForm.parentOrgId) {
                        $scope.queryOrgConfig.defaultSelect = [$scope.orgList[i]]
                        $scope.selectedOrgList = [$scope.orgList[i]]
                        $scope.userType && $scope.filterNotTreeStructureData($scope.orgList)
                        break
                    }
                }
            })
        }
        // 新增返回对应树形结构数据
        $scope.filterData = function (notTreeStructure, orgList, parentOrgId) {
            // 排序 当前父级id
            $scope.queryOrgConfig.parentId = parentOrgId
            if (notTreeStructure) {
                $scope.orgList = orgList.filter((x) => {
                    return x.notTreeStructure == true
                })
            } else {
                $scope.orgList = orgList.filter((x) => {
                    return x.notTreeStructure == false
                })
            }
            $scope.orgListNodeCtrl($scope.orgList)
        }
        // 编辑返回对应树形结构 非admin会存在独享角色 不与所属机构同级
        $scope.filterNotTreeStructureData = function (data) {
            $scope.orgList = data.filter((x) => {
                return x.notTreeStructure == false
            })
            angular.forEach($scope.orgList, function (item, index) {
                if (item.orgId == $scope.orgOwnerShip) {
                    $scope.queryOrgConfig.parentId = item.parentOrgId
                }
            })
            $scope.orgListNodeCtrl($scope.orgList)
        }
        // node控制
        $scope.orgListNodeCtrl = function (orgList) {
            angular.forEach(orgList, (item) => {
                item.open = true
                item.checked = false
            })
        }
        $scope.queryOrgConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            //queryType: 'statistTree',
            queryType: 'radioTree',
            parentIdName: 'parentOrgId',
            multiple: false,
            // 修改
            parentId: $scope.userType ? $scope.parentOrgId : -1,
            defaultSelect: [],
        }
        // 机构变化
        $scope.orgSelectChange = function (v) {
            console.log(v)
            if (!v[0].orgId) {
                return
            }
            $scope.queryOrgConfig.defaultSelect = v
            $scope.orgForm.parentOrgId = v[0].orgId
            $scope.orgForm.parentOrgName = v[0].orgName
            $scope.orgForm.parentLevelCode = v[0].treeLevelCode
        }
        $scope.dictData = {}
        httpRequest.get_dictByTypeArr('["taxplayer_type","ivat_common_flag","industry_classification","accounting_system","register_type","department_no"]').then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value) //纳税人类型
            $scope.dictData.taxplayer_type = $scope.dictData.taxplayer_type.filter((x) => {
                return x.enumName == '一般纳税人' || x.enumName == '小规模纳税人'
            })
            //企业类型//$scope.registeraS2 = {}
            $scope.registerOptions = { data: [] }
            $scope.registerOptions.placeholder = '请选择'
            const registerList = toSelect2data($scope.dictData.register_type, 'enumCode', 'enumName')
            $scope.registerOptions.data = registerList
            //所属行业//$scope.industryaS2 = {}
            $scope.industryOptions = { data: [] }
            $scope.industryOptions.placeholder = '请选择'
            const industryList = toSelect2data($scope.dictData.industry_classification, 'enumCode', 'enumName')
            $scope.industryOptions.data = industryList
            //会计制度//$scope.accountingaS2 = {}
            $scope.accountingOptions = { data: [] }
            $scope.accountingOptions.placeholder = '请选择'
            const accountingList = toSelect2data($scope.dictData.accounting_system, 'enumCode', 'enumName')
            $scope.accountingOptions.data = accountingList
        })

        // 验证规则
        $scope.validateRules = {
            saleCreditCode: [
                {
                    erromsg: '信用代码必须等于15位、17位、18位、20位或21位',
                    condition(value) {
                        // 规则
                        return !globalFn.checkTax(value)
                    },
                },
            ],
            orgName: [
                {
                    erromsg: '机构名称，最少2位字符,最多100位字符',
                    condition(value) {
                        // 规则
                        return !(value.toString().length >= 2 && value.toString().length <= 100)
                    },
                },
            ],
            regionNo: [
                {
                    erromsg: '必填项',
                    condition(value) {
                        // 规则
                        return !value
                    },
                },
            ],
        }
        // 纳税人识别号检测
        $scope.taxNoChange = function () {
            if ($scope.orgForm.saleCreditCode !== '' && !globalFn.checkTax($scope.orgForm.saleCreditCode)) {
                logger.logError('纳税人识别号格式错误！')
            }
        }
        // 新增
        $scope.submit = function (continiuFlag) {
            const ret = formvalidateApi.run()
            if (ret) {
                let chooseTaxBureau = $scope.taxBureauList.filter((item) => {
                    return item.id == $scope.orgForm.saleInfo.taxBureauId
                })
                $scope.orgForm.saleInfo.province = chooseTaxBureau[0].province
                $scope.orgForm.saleCreditCode = $scope.orgForm.saleInfo.saleCreditCode
                $scope.orgForm.saleInfo.saleName = $scope.orgForm.orgName
                $scope.orgForm.taxplayerType = $scope.orgForm.saleInfo.taxplayerType
                $scope.orgForm.saleInfo.phone = $scope.orgForm.orgPhone
                $scope.orgForm.saleInfo.registerAddress = $scope.orgForm.orgAddress
                $scope.orgForm.saleInfo.departmentNo = $scope.orgForm.saleInfo.affiliation
                $scope.orgForm.saleInfo.managerCityNo = $scope.cityRegionNo
                $scope.orgForm.saleInfo.regionNo = $scope.orgForm.saleInfo.regionNo
                console.log($scope.orgForm)
                const method = orgId ? 'post_updateOrganization' : 'post_addOrganization'
                const methodMSG = orgId ? '保存成功' : '新增机构成功'
                utils.loading()
                httpRequest[method]($scope.orgForm).then((res) => {
                    if (continiuFlag) {
                        $scope.reset(methodMSG)
                    } else {
                        logger.logSuccess(methodMSG)
                        $state.go('system.syssetting.org.list', { reload: true })
                    }
                })
            }
        }
        // 返回
        $scope.cancel = function () {
            $state.go('system.syssetting.org.list', { reload: true })
        }

        // 根据当前编辑页面的 纳税人编码 命中 taxpayerOptions.data  设置  s2item 对象
        // $scope.taxpayerOptions.data
        // 适配组件数据接口
        function toSelect2data(list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    id: '',
                    text: '',
                }
                $.extend(tempdata, list[a])
                tempdata.id = list[a][idfield]
                tempdata.text = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }

        $scope.selectFun = function () {
            const modalInstance = $uibModal.open({
                template: packageModalPage,
                controller: 'packageModalCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                resolve: {
                    items1() {
                        return { selectedFunList: $scope.orgForm.packIdList }
                    },
                },
            })
            modalInstance.result.then((item) => {
                if (item.selectedList) {
                    $scope.orgForm.packIdList = item.selectedList
                }
            })
        }
    }
}
orgAddCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'globalFn', '$stateParams', 'formvalidateApi', '$rootScope']
export default orgAddCtrl



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/org/orgAddCtrl.js